export default __webpack_public_path__ + "static/media/space-2.edd055f6.svg";